/**
 * ツイッター、インスタの遅延読み込み
 */
function twitterLazyLoad(src) {

    const scriptTag = document.createElement('script');
    scriptTag.src = src;
    scriptTag.async = true;

    document.body.appendChild(scriptTag);
}

function doTwitterLazyLoad() {
    const lazyLoadTwitter = document.getElementsByClassName('js-lazy-load-twitter');
    const lazyLoadInstagram = document.getElementsByClassName('js-lazy-load-instagram');
    try {
        if (lazyLoadTwitter.length !== 0) twitterLazyLoad('https://platform.twitter.com/widgets.js');
        if (lazyLoadInstagram.length !== 0) twitterLazyLoad('//www.instagram.com/embed.js');
    } catch (error) {
        // console.log(error);
    }
}
window.addEventListener('scroll', doTwitterLazyLoad, { once: true });